import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import GroupIcon from "@material-ui/icons/Group";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _SearchResultTable } from "../components";
import { GetGroupListColumns } from "../components/SearchTableColumns/GroupListColumns";
import useTable from "../hooks/Table";

export const _GroupList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Gruppo: "", Gruppo: "" });
    const { Data, Options, IsLoading } = useTable("/api/Gruppo/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("GruppoController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Utente", ID_MenuMain: 32 });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={GroupIcon} Title="Gruppi" />
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Gruppo"
                                    label={Trad.Trad("ID")}
                                    value={FormData.ID_Gruppo}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField fullWidth id="Gruppo" label={Trad.Trad("Nome")} value={FormData.Gruppo} onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_SearchResultTable Data={Data} Columns={GetGroupListColumns()} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/GroupList.tsx